import AdminApiService from "../api/AdminApiService";
import { IAdminUserListRequest, INeedsApprovalCountResponse } from "../types/XSifterApiRequestTypes";
import { IXSifterEditingUser, IXSifterUser, IXSifterUserListing } from "../types/XSifterAppUser";
import UserAuthService from "./UserAuthService";

export default class XSifterAdminService {
    private userAuthService = UserAuthService.getInstance();
    private adminApi = new AdminApiService();

    public async getNumNeedingApproval(currentUser?: IXSifterUser) : Promise<INeedsApprovalCountResponse> {
        if (!currentUser || currentUser.role !== 'admin')
            return new Promise<INeedsApprovalCountResponse>((resolve, reject) => {
                reject();
            });
        return this.adminApi.getNumNeedingApproval(this.userAuthService.getToken() ?? "");
    }

    public async getUserList(request: IAdminUserListRequest, currentUser?: IXSifterUser): Promise<IXSifterUserListing> {
        if (!currentUser || currentUser.role !== 'admin')
            return new Promise<IXSifterUserListing>((resolve, reject) => {
                reject();
            });

        return this.adminApi.getUserList(this.userAuthService.getToken() ?? "", request);
    }

    public async approveUser(userId: number, currentUser?: IXSifterUser): Promise<boolean> {
        if (!currentUser || currentUser.role !== 'admin')
            return new Promise<boolean>((resolve, reject) => {
                reject();
            });

        return this.adminApi.approveUser(this.userAuthService.getToken() ?? "", userId);
    }

    public async getUserInfo(userId: number, currentUser?: IXSifterUser): Promise<IXSifterEditingUser | undefined> {
        if (!currentUser || currentUser.role !== 'admin')
            return new Promise<IXSifterEditingUser | undefined>((resolve, reject) => {
                reject();
            });

        return this.adminApi.getUserInfo(this.userAuthService.getToken() ?? "", userId);
    }

    public async updateUser(userId: number, patchList: any[],  currentUser?: IXSifterUser): Promise<boolean> {
        if (!currentUser || currentUser.role !== 'admin')
            return new Promise<boolean>((resolve, reject) => {
                reject(false);
            });

        return this.adminApi.updateUser(this.userAuthService.getToken() ?? "", userId, patchList);
    }

    public async addCreditsForUser(userId: number, creditAmount: number, currentUser?: IXSifterUser): Promise<boolean> {
        if (!currentUser || currentUser.role !== 'admin')
            return new Promise<boolean>((resolve, reject) => {
                reject(false);
            });

        return this.adminApi.addCreditsForUser(this.userAuthService.getToken() ?? "", userId, creditAmount);
    }
};
